/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Destination_DescriptionInputs */



/**
* | output |
* | --- |
* | "Only spaces you can write to are listed; projects appear here too." |
*
* @param {Agent_Builder_Destination_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_destination_description = /** @type {((inputs?: Agent_Builder_Destination_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Destination_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es werden nur Bereiche angezeigt, in die Sie schreiben dürfen; Projekte erscheinen ebenfalls hier.")
	return /** @type {LocalizedString} */ ("Only spaces you can write to are listed; projects appear here too.")
});